import { Divider, Grid, Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { OperacaoTipo, GrupoAcesso, FuncaoParticipante } from 'common/genericTypes';
import { Button, Dropdown, LgSpace, MdSpace, Option } from 'm2m.components';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { convertTZ } from 'utils/date';
import {
  opcoesDeTipoDeMovimentacaoDoCustodiante,
  opcoesDeTipoDeMovimentacaoDoUsuarioOperacoes,
} from './opcoesDeTipoDeMovimentacao';

const CadastrarOperacoes: React.FC = () => {
  const [operacaoTipoOptions, setOperacaoTipoOptions] = useState<Array<Option>>([]);
  const [operacaoTipo, setOperacaoTipo] = useState<string>('');
  const [invalidOperation, setInvalidOperation] = useState(false);

  const history = useHistory();

  const isParticipanteCustodiante =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;

  const handleRegisterClick = () => {
    const compraVendaValid = isCompraVendaValid();
    const compraVendaCompromissadaValid = isCompraVendaCompromissadaValid();
    const transferenciaValid = isTransferenciaValid();
    const ofertaPrimariaValid = isOfertaPrimariaValid();

    switch (operacaoTipo) {
      case OperacaoTipo.OfertaPrimaria:
        setInvalidOperation(!ofertaPrimariaValid);
        if (ofertaPrimariaValid) history.push('/operacoes/gerenciar/oferta-primaria/cadastro');
        break;
      case OperacaoTipo.Compra:
        setInvalidOperation(!compraVendaValid);
        if (compraVendaValid) history.push('/operacoes/gerenciar/compra/cadastro');
        break;
      case OperacaoTipo.Venda:
        setInvalidOperation(!compraVendaValid);
        if (compraVendaValid) history.push('/operacoes/gerenciar/venda/cadastro');
        break;
        case OperacaoTipo.CompraVendaCompromissada:
          setInvalidOperation(compraVendaCompromissadaValid);
          if (compraVendaCompromissadaValid) history.push('/operacoes/gerenciar/compra-venda-compromissada/cadastro');
          break;
      case OperacaoTipo.SaidaInteroperabilidade:
        setInvalidOperation(!transferenciaValid);
        if (transferenciaValid) history.push('/operacoes/gerenciar/interoperabilidade/solicitacao');
        break;
      case OperacaoTipo.TransferenciaInterop:
        history.push('/operacoes/gerenciar/interoperabilidade/cadastro');
        break;
      case OperacaoTipo.Transferencia:
        history.push('/operacoes/gerenciar/transferencia/cadastro');
        break;
      case OperacaoTipo.TransferenciaUnificada:
        setInvalidOperation(!transferenciaValid);
        if (transferenciaValid) history.push('/operacoes/gerenciar/transferencia-unificada/cadastro');
        break;
      case OperacaoTipo.CancelamentoQuantidades:
        history.push('/operacoes/gerenciar/cancelamento/quantidades/cadastro');
        break;
      default:
        console.warn('Operação não habilitada');
        break;
    }
  };

  const isOfertaPrimariaValid = () => {
    const startTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_OFERTA_PRIMARIA_START_TIME'];
    const endTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_OFERTA_PRIMARIA_END_TIME'];
    return !(moment().isSameOrAfter(convertTZ(moment(endTime))) || moment().isBefore(convertTZ(moment(startTime))));
  };

  const isCompraVendaValid = () => {
    const startTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_COMPRA_VENDA_START_TIME'];
    const endTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_COMPRA_VENDA_END_TIME'];
    return !(moment().isSameOrAfter(convertTZ(moment(endTime))) || moment().isBefore(convertTZ(moment(startTime))));
  };

  const isCompraVendaCompromissadaValid = () => {
    const startTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_COMPRA_VENDA_COMPROMISSADA_START_TIME'];
    const endTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_COMPRA_VENDA_COMPROMISSADA_END_TIME'];
    return !(moment().isSameOrAfter(convertTZ(moment(endTime))) || moment().isBefore(convertTZ(moment(startTime))));
  };

  const isTransferenciaValid = () => {
    const startTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_TRANSFERENCIA_START_TIME'];
    const endTime = moment().format('YYYY-MM-DDT') + process.env['REACT_APP_OPERACAO_TRANSFERENCIA_END_TIME'];
    return !(moment().isSameOrAfter(convertTZ(moment(endTime))) || moment().isBefore(convertTZ(moment(startTime))));
  };

  useEffect(() => {
    if (isParticipanteCustodiante) setOperacaoTipoOptions(opcoesDeTipoDeMovimentacaoDoCustodiante);
    if (isUsuarioOperacoes) setOperacaoTipoOptions(opcoesDeTipoDeMovimentacaoDoUsuarioOperacoes);
  }, []);

  return (
    <div style={{ marginRight: 40 }}>
      <Grid container justify={'space-between'} direction={'row'} alignItems={'center'}>
        <Typography variant="h1">{'Cadastro de Movimentação'}</Typography>
      </Grid>
      <LgSpace />
      <Divider variant="fullWidth" />
      <MdSpace />
      <Grid container justify="center">
        <Grid item md={4}>
          <Typography variant="h3" align="center">
            {'Antes de começar, nos informe o tipo de movimentação a ser cadastrada:'}
          </Typography>
          <MdSpace />
          <Dropdown
            label="Tipo de Movimentação"
            value={operacaoTipo}
            onChange={setOperacaoTipo}
            options={operacaoTipoOptions}
            required
          />
          <MdSpace />
          {invalidOperation && (
            <div
              style={{
                marginBottom: '20px',
                padding: '20px',
                border: '2px solid #FFCF40',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <ErrorIcon style={{ marginRight: 10 }} fontSize="small" />
              <Typography variant="body1">
                {'O comando de movimentação não pode ocorrer fora do horário permitido.'}
              </Typography>
            </div>
          )}
        </Grid>
      </Grid>
      <Grid container justify="center">
        <Grid item>
          <Button variant="contained" color="primary" onClick={handleRegisterClick} disabled={!operacaoTipo}>
            {'Prosseguir'}
          </Button>
          <MdSpace />
        </Grid>
      </Grid>
    </div>
  );
};

export default CadastrarOperacoes;
